import {StyledDiv, StyledH1, StyledH2, StyledHR, StyledP, StyledSpan} from './StyledTypeDefinitions'
import styled, {css, FlattenSimpleInterpolation} from 'styled-components'
import {BreakPoint, Colors, FontSize, FontWeights} from './Constants'
import {FlexGrowContent} from './FlexComponents'
import {generateMedia} from 'styled-media-query';
import {currentMedia} from './ResponsiveConvenience'
import {
    WideWhiteArea
} from '../__NoAutomatedTests/components/applications/common/resident/NatResidentApplicationsCommon'

const ContentsAreaPadding: string = '15px';

const breakPoint: any = generateMedia({
    sp: `${BreakPoint.Sp}`,
});

export const ContentsAreaComponent = styled(FlexGrowContent)`
    background-color: ${Colors.Background};
    box-sizing: border-box;
    padding: ${ContentsAreaPadding};
    flex-basis: auto;
`;

export const ContentsTitle: StyledH1 = styled.h1`
  margin: 1.5rem 0 2rem 0;
  font-size: 2.4rem;
  line-height: 2.4rem;
  font-weight: ${FontWeights.Bold};
  color: ${Colors.AccentDark};
`;

// メインタイトル
export const ContentsMainTitle: StyledH1 = styled.h1`
  font-size: ${FontSize.Big};
  font-weight: ${FontWeights.Bold};
  margin-top: 30px;
  margin-bottom: 10px;
  padding: 0;
  text-align: center;
`;

// サブタイトル ラッパー
export const ContentsSubTitleWrapper: StyledH2 = styled.h2`
  font-size: ${FontSize.Accent};
  font-weight: ${FontWeights.Bold};
  position: relative;
  margin-top: 30px;
  margin-bottom: 10px;
  padding: 0;
  text-align: center;

  &::before {
    display: block;
    position: absolute;
    top: 50%;
    width: 100%;
    height: 1px;
    border-top: solid 1px ${Colors.AccentDark};
    content: "";
    z-index: 1;
    }
`;

// サブタイトル
export const ContentsSubTitleInner: StyledDiv = styled.div`
    display: inline-block;
    position: relative;
    padding: 0 12px;
    background: ${Colors.Background};
    z-index: 5;

  ${breakPoint.lessThan('sp')`
    width: 80%;
    max-width: 230px;
  `}
`;

// メインタイトル（ボーダーデザイン）
export const ContentsMainTitleBorder: StyledDiv = styled.div`
    display: inline-block;
    padding-left: 15px;
    border-left: 5px solid ${Colors.Primary};
    font-weight: ${FontWeights.Bold};
`
;

// メインコンテンツ
export const MainContainer: StyledDiv = styled.div`
  padding: ${ContentsAreaPadding};
  background-color: ${Colors.Surface};
`;

export const WideMainContainer = styled.div`
  background-color: ${Colors.Surface};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
  padding: 0 15px;
  box-sizing: border-box;
  overflow: hidden;
`

// 文章
export const ParagraphText: StyledP = styled.p`
   margin: 0 0 ${ContentsAreaPadding} 0;
`;

// 注釈
export const Comment: StyledSpan = styled.span`
   font-size: ${FontSize.Small};
`;

// 注釈（赤字）
export const Note: StyledDiv = styled.div`
  font-size: ${FontSize.Small};
  color: ${Colors.Alert};;
`;

// 太字
export const TxtBold: StyledSpan = styled.span`
    font-weight: ${FontWeights.Bold}
`;

export const Divider: StyledHR = styled.hr`
  height: 1px;
  border: none;
  border-bottom: 1px solid ${Colors.AccentLight};
  margin-left: -${ContentsAreaPadding};
  margin-right: -${ContentsAreaPadding};
`;
// フォントアイコン
export const IconFont: FlattenSimpleInterpolation = css`
  font-family: "icon-hsc_sutekinet";
  display: inline-block;
  vertical-align: middle;
  line-height: 1;
  font-weight: normal;
  font-style: normal;
  speak: none;
  text-decoration: inherit;
  text-transform: none;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;
